import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-filter-icon',
    templateUrl: './filter-icon.component.html',
    styleUrls: ['./filter-icon.component.scss']
})
export class FilterIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 30;
    }
}
